import React from 'react';
import styled from 'styled-components';
import { PlaceholderBlock } from '../../../../styled/placeholders.styled';
import { Breakpoints } from '../../../../styled/constants';

const GalleryPlaceHolder = styled(PlaceholderBlock)`
  @media (min-width: ${Breakpoints.tablet}px) {
    border-radius: 14px;
  }
`;

export const CurrentItemGalleryPlaceholder: React.FC = () => (
  <GalleryPlaceHolder height="330px" margin="0" borderRadius="0" />
);
